<template>
  <div>
    <!-- breadcrumb area start -->
    <div class="breadcrumb-area">
      <div class="row">
        <div class="col-md-12">
          <ol class="breadcrumb font-class">
            <li><a href="/#/home" v-on:click="sendMsg"><span class="fa fa-home"></span></a></li>
            <li><a href="/#/center" v-on:click="sendMsg">核心业务</a></li>
            <li class="active">大坝振动监测</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- breadcrumb area end -->

    <!-- contact information start -->
    <div class="contant-information pt-20">
      <div class="row">
        <div class="center_column col-xs-12 col-sm-12">
          <div class="rte">
            <h1 style="text-align:center;font-size: 20px">大坝振动监测</h1>
            <hr>
            <p class="titleP">大坝振动监测概述</p>
            <p>大坝振动安全监测是人们了解大坝运行状态和安全状况的有效手段和办法，大坝及其有关设施的振动特性 (频率、振型及阻尼等 )及其变化趋势是表征坝体结构力学性态与运行状况的重要标志，在大坝安全评估中有着重要意义。大坝的振动监测主要由三大部分构成：1、水轮发电机组的振动监测；2、水轮发电机组与坝体的耦合振动；3、大坝本体的强震监测。通过各种信息的获取、整理和分析，给出大坝安全评价，保证大坝安全运行。</p>
            <p class="titleP">针对大坝监测提供监测设备配套</p>
            <br>
            <h6 style="text-align: center">水轮发电机组振动监测/与大坝建筑结构耦合振动监测(在线监测)</h6>
            <table border="1" style="text-align:center;">
              <tr>
                <th><p>产品型号</p></th>
                <th><p>产品概述</p></th>
              </tr>
              <tr>
                <td><p>D3000型动态数据采集仪</p></td>
                <td><p>物联网型振动数据采集仪，适用于风机塔筒和塔架结构的振动长期监测</p></td>
              </tr>
              <tr>
                <td><p>BY-S07型低频振动传感器</p></td>
                <td><p>频率范围：0.14~100Hz，四档选择，可直接测速度/加速度（单向/双向/三向），防护等级IP67</p></td>
              </tr>
              <tr>
                <td><p>BY-S07B型低频振动传感器</p></td>
                <td><p>可同时输出速度信号和动位移信号，防护等级IP67</p></td>
              </tr>
            </table>
            <br>
            <h6 style="text-align: center">强震监测(在线监测)</h6>
            <table border="1" style="text-align:center;">
              <tr>
                <th><p>产品型号</p></th>
                <th><p>产品概述</p></th>
              </tr>
              <tr>
                <td><p>BY-D2000A型工程强震仪</p></td>
                <td><p>BY-D2000A型工程强震仪具有强震预警、烈度速算、邮件速报等功能</p></td>
              </tr>
              <tr>
                <td><p>BY-S07型低频振动传感器</p></td>
                <td><p>频率范围：0.14~100Hz，四档选择，可直接测速度/加速度（单向/双向/三向），防护等级IP67</p></td>
              </tr>
            </table>
            <p class="titleP">系统特点：</p>
            <p>1.采集仪： D3000型动态数据采集仪采用独立24bitADC并行同步采集，
              动态范围可达120dB以上，设备可级联扩展至128通道，采用直流适配器15V供电，
              也支持外接直流电池（蓄电池）供电，有外部供电时时使用外部供电，
              并给内置电池供电，无外部供电时，自动切换至内置电池供电，
              内置TF储存卡，在自然灾害来临（断电/断网），仪器仍正常工作，
              数据储存至TF卡中，保证数据采集的连续性。采集仪开放底层协议，
              可使用C语言、Python语言等进行对接，还可对接用户的监测平台。</p>
            <p>2.传感器：传感器使用了无源伺服反馈技术，输出模拟电压信号，
            宽频带、高分辨率、大动态范围、抗冲击性能好，可直接与数据采集仪配接。
              传感器可在恶劣环境下工作，-40℃~+85℃。耐潮耐湿，防护等级IP67。</p>
            <p>3.强震仪：24bit采样精度。采样率100、200、500、1000可选。
            主机硬件内置低通硬件滤波和抗混叠滤波。主机通道数（兼容传感器数量）
            最多可连接5个传感器（三向），STA/LTA（短窗平均-长窗平均）触发算法，加权投票判断地震事件。
            </p>
            <p class="titleP">大坝水电站振动监测案例</p>
            <div style="width:80%;margin: 0 auto 50px">
              <img src="../../../assets/center/dam/c1.png" alt="" style="width:100%;height:auto;">
            </div>
            <p>公司先后参与了四川、云南、新疆、湖北、浙江等省的大坝水电站振动监测项目。</p>
            <p class="titleP">大坝水电站振动监测流程图（方案一）</p>
            <div style="width:80%;margin: 0 auto 50px">
              <img src="../../../assets/center/dam/f1.png" alt="" style="width:100%;height:auto;">
            </div>
            <p class="titleP">大坝水电站振动监测流程图（方案二）</p>
            <div style="width:60%;margin: 0 auto 50px">
              <img src="../../../assets/center/dam/f2.png" alt="" style="width:100%;height:auto;">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- contact information end -->
  </div>
</template>

<script>
import {getContactDetail} from '../../../utils/api'

export default {
  name: 'contact',
  data () {
    return {
      contactData: {},
      formLeft: {
        input1: '',
        input2: '',
        input3: ''
      }
    }
  },
  mounted () {
    this.getContactDetail()
  },
  methods: {
    render (String) {
      let temp = ''
      for (let item of String.split('\n')) {
        temp += item + '<br>'
      }
      return temp
    },
    async getContactDetail () {
      let contactData01 = await getContactDetail()
      if (localStorage.getItem('Language') === 'zh') {
        this.contactData = {
          address: this.render(contactData01.address_zh),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_zh)
        }
      } else {
        this.contactData = {
          address: this.render(contactData01.address_en),
          email: contactData01.email,
          phone: contactData01.phone,
          work_time: this.render(contactData01.work_time_en)
        }
      }
      // console.log(this.contactData)
    },
    sendMsg () {
      this.$emit('headCurrent', 0)
      window.sessionStorage.setItem('currentFirstIndex', 0)
    }
  }
}
</script>

<!-- 面包屑导航样式 -->
<style scoped>
  .breadcrumb>li+li:before {
    padding: 0 5px;
    color: #000;
    content: ">";
    font-weight: lighter;
  }

  .breadcrumb>li span{
    font-size: 16px;
  }
</style>

<!-- 内容样式 -->
<style scoped>
  .center_column{
    min-height: 400px;
  }

  .center_column p{
    font-size: 14px;
    line-height: 22px;
    margin: 0 0 9px;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    color: #000;
    position: relative;
    font-family: 宋体;
  }

  .titleP{
    padding-left: 10px!important;
    font-size: 16px;
    font-weight: bold;
    margin: 10px 0 10px!important;
    font-family: 宋体;
    text-indent: 0!important;
  }

  .titleP:before{
    position: absolute;
    left: -5px;
    top: 0;
    content: "\2726";
    font-size: 14px;
  }

  .rte {
    background: transparent none repeat scroll 0 0;
    text-indent: 26px;
  }

  .rte img{
    width: 100%;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/center/dam/dam.vue